var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('periodic-performance',{attrs:{"title":_vm.title},model:{value:(_vm.leadDealer),callback:function ($$v) {_vm.leadDealer=$$v},expression:"leadDealer"}})}
var staticRenderFns = []

export { render, staticRenderFns }